module.exports = __webpack_public_path__ + "static/websecurity-d78b28bf602c179dfc6225deb02445e3.png";